interface StyleObject {
  [key: string]: string | number;
}

export enum RevealEffect {
  Fade = 'fade',
  Zoom = 'zoom'
}

export interface RevealEffectClasses {
  fade: string;
  zoom: string;
}

export interface FadeStartStyles {
  center: StyleObject;
  up: StyleObject;
}

export interface RevealEffectStartStyles {
  fade: FadeStartStyles;
  zoom: StyleObject;
}

export interface RevealEffectConfig {
  selector: string;
  revealEffect: RevealEffect;
  cascadeChildren?: boolean;
}

export interface RevealEffectKeyframes {
  to: React.CSSProperties;
}

export interface RevealEffectAnimationDescription {
  animation: string;
  animationFillMode: string;
}

export interface RevealEffectDefinitionFadeAnimation {
  fade: RevealEffectAnimationDescription;
  '@keyframes fadeOpacity': RevealEffectKeyframes;
  '@keyframes fadeTransform': RevealEffectKeyframes;
}

export interface RevealEffectDefinitionZoomAnimation {
  zoom: RevealEffectAnimationDescription;
  '@keyframes zoomOpacity': RevealEffectKeyframes;
  '@keyframes zoomTransform': RevealEffectKeyframes;
}

export type RevealEffectDefinitionAnimation = RevealEffectDefinitionFadeAnimation | RevealEffectDefinitionZoomAnimation;

export interface RevealEffectDefinition {
  name: string;
  start: FadeStartStyles | StyleObject;
  animation: RevealEffectDefinitionAnimation;
  shouldReveal(element: Element): boolean;
  reveal(element: Element, classes: RevealEffectClasses): void;
}
